import React, { useMemo, useCallback, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Row, Col, Modal, Checkbox } from "antd";

import config from "../../../config";
import {
  put,
  checkResponse,
  checkHttpStatus,
  CLIENT_PLACEHOLDER,
} from "../../../modules/httpFunctions";
import InfoLabel from "../../app/generic/infoLabel";
import ExternalLink from "../../app/generic/externalLink";
import { handleError } from "../../../modules/errorLogger";
import { error, success } from "../../../modules/messages";
import { parseDate } from "../../../modules/consignmentFunctions";

const { confirm } = Modal;

const Terms = ({ client, onClientLoad }) => {
  const intl = useIntl();

  const disabledCheck = useMemo(
    () =>
      !client.agreeWithTerms ||
      (client.registrationLevel !== "FIRST" &&
        client.registrationLevel !== "SECOND"),
    [client]
  );

  const [currentValue, setCurrentValue] = useState(
    client.agreeWithTerms ? true : false
  );
  const handleCheckChange = useCallback(
    ({ target }) => {
      setCurrentValue(target.checked);
      !disabledCheck &&
        confirm({
          title: intl.formatMessage({
            id: "contracts.terms.check.question.title",
            defaultMessage:
              "Opravdu si přejete odvolat souhlas s obchodními podmínkami?",
          }),
          content: intl.formatMessage({
            id: "contracts.terms.check.question",
            defaultMessage:
              "Pokud odeberete souhlas, dojde k zablokování odesílání zásilek do DHL!",
          }),
          onOk() {
            const onError = (r) => {
              error(
                (r && r.data.message) ||
                  intl.formatMessage({
                    id: "contracts.terms.check.question.error",
                    defaultMessage:
                      "Při odebírání souhlasu nastala chyba, zkuste to prosím znovu!",
                  })
              );
              setCurrentValue(true);
            };
            put(`client/${CLIENT_PLACEHOLDER}/agree-with-terms`, {
              agree: target.checked,
            })
              .then((r) => {
                if (checkHttpStatus(r) && checkResponse(r)) {
                  success(
                    intl.formatMessage({
                      id: "contracts.terms.check.question.success",
                      defaultMessage:
                        "Souhlas s obchodmími podmínkami DHL Freight byl odebrán!",
                    })
                  );
                  onClientLoad && onClientLoad();
                } else {
                  onError(r);
                }
              })
              .catch((err) => {
                handleError(err);
                onError();
              });
          },
          onCancel() {
            setCurrentValue(true);
          },
          okText: intl.formatMessage({
            id: "messages.yes",
            defaultMessage: "Ano",
          }),
        });
    },
    [intl, disabledCheck, onClientLoad]
  );

  return (
    <Row gutter={[0, 20]}>
      <Col>
        <Checkbox
          checked={currentValue}
          disabled={disabledCheck}
          onChange={handleCheckChange}
        >
          <InfoLabel
            label={
              <FormattedMessage
                id="contracts.terms.check"
                defaultMessage="souhlasím s obchodními podmínkami DHL Freight CZ"
              />
            }
            info={
              disabledCheck ? (
                client.agreeWithTerms ? (
                  <FormattedMessage
                    id="contracts.terms.check.contract"
                    defaultMessage="Souhlas není možné odvolat z důvodu uzavřené smlouvy."
                  />
                ) : (
                  <FormattedMessage
                    id="contracts.terms.check.no"
                    defaultMessage="Souhlas byl odvolán, není možné odesílat zásilky do DHL."
                  />
                )
              ) : client.agreeWithTerms ? (
                <FormattedMessage
                  id="contracts.terms.check.agree"
                  defaultMessage="V případě odvolání souhlasu dojde k blokaci odesílání zásilek do DHL."
                />
              ) : (
                <FormattedMessage
                  id="contracts.terms.check.agree.no"
                  defaultMessage="V případě souhlasu dojde k povolení odesílání zásilek do DHL."
                />
              )
            }
          />
        </Checkbox>
      </Col>
      {client.agreeWithTerms && (
        <Col>
          <FormattedMessage
            id="contracts.terms.agree"
            values={{ date: parseDate(client.agreeWithTerms) }}
            defaultMessage="Souhlas s obchodními podmínkami je platný od {date}."
          />
        </Col>
      )}
      <Col>
        <ExternalLink
          id="contracts.terms.here"
          href={config.TERMS_DOCUMENT_URL}
          defaultMessage="aktuální obchodní podmínky pro tisk"
        />
      </Col>
    </Row>
  );
};

export default Terms;
